import React from 'react';
import MiInversion from './MiInversion';

const MiInversionPage = () => {
  return (
    <div style={{padding: '32px'}}>
      <MiInversion />
    </div>
  );
};

export default MiInversionPage;
